import { axios } from '@/utils/request'

const api = {
  rewardsList: '/adminapi/qcxj/rewardsList', 
}

export default api

export function getRewardsList(parameter) {
  return axios({
    url: api.rewardsList,
    method: 'get',
    params: parameter
  })
}
 
export function rewardsDetail(parameter) {
  return axios({
    url: '/adminapi/qcxj/rewardsDetail',
    method: 'get',
    params: parameter
  })
}
 
export function rewardsEdit(parameter) {
  return axios({
    url: '/adminapi/qcxj/rewardsEdit',
    method: 'post',
    data: parameter
  })
}
 
export function rewardsDelete(parameter) {
  return axios({
    url: '/adminapi/qcxj/rewardsDelete',
    method: 'post',
    data: parameter
  })
}
 
export function rewardsCompute(parameter) {
  return axios({
    url: '/adminapi/qcxj/rewardsCompute',
    method: 'post',
    data: parameter
  })
}
 
export function rewardsCityCompute(parameter) {
  return axios({
    url: '/adminapi/qcxj/rewardsCityCompute',
    method: 'post',
    data: parameter
  })
}
 
export function rewardsTuijianCompute(parameter) {
  return axios({
    url: '/adminapi/qcxj/rewardsTuijianCompute',
    method: 'post',
    data: parameter
  })
}
 
export function getCityList(parameter) {
  return axios({
    url: '/adminapi/qcxj/cityList',
    method: 'post',
    data: parameter
  })
}

 
 
export function getCityUserList(parameter) {
  return axios({
    url: '/adminapi/qcxj/cityUserList',
    method: 'post',
    data: parameter
  })
}
 
export function addCityUser(parameter) {
  return axios({
    url: '/adminapi/qcxj/addCityUser',
    method: 'post',
    data: parameter
  })
}
 
export function deleteCityUser(parameter) {
  return axios({
    url: '/adminapi/qcxj/deleteCityUser',
    method: 'post',
    data: parameter
  })
}
 